'use strict';

// todo: aria-expanded="true|false" on all collapsible content (accordions, tags, etc)

+function ($) {

  $.fn.accordion = function (option) {
    return this.each(function () {
      switch (option) {
      case 'show':
        if ($(this).parent().find('[data-toggle="collapse"]:first').hasClass('disabled')) return false;
        $(this).parent().find('[data-toggle="collapse"]:first').removeClass('collapsed').addClass('active');
        break;
      case 'hide':
        if ($(this).parent().find('[data-toggle="collapse"]:first').hasClass('disabled')) return false;
        $(this).parent().find('[data-toggle="collapse"]:first').addClass('collapsed').removeClass('active');
        break;
      case 'toggle':
        // prevent panels inside of accordions from doing anything to the accordion
        if ($(this).closest('.panel').length > 0) return false;
        // prevent open/close if toggle has class disabled on it
        if ($(this).hasClass('disabled')) return false;
        // progress-steps: exactly 1 accordion may be open at a time (and cannot be closed)
        // accordion-group: 0 or 1 accordions may be open at a time
        var $container = $(this).parent().parent();
        if ($container.is('[data-progress-steps], [data-accordion-group]')) {
          // close all OTHER accordions on the SAME level
          $container.find('> * > [data-toggle="collapse"]').not(this).next('.collapse').collapse('hide');
          // extra measure to prevent two steps opening at the same time when clicked too quickly
          var allowClose = $container.is('[data-accordion-group]') && $(this).hasClass('active');
          if ($container.find('> * > [data-toggle="collapse"]:not(.collapsed)').length > 0 && !allowClose) return;
        }
        // open/close this accordion
        $(this).next('.collapse').collapse('toggle');
        break;
      }
    });
  };

  $(document)
  // prevent open/close if toggle has class disabled on it, and
  // add/remove active/collapsed classes on the toggle for additional styling
  .on('show.bs.collapse', '.collapse', function (e) {
    e.stopPropagation();
    $(e.target).accordion('show');
  })
  .on('hide.bs.collapse', '.collapse', function (e) {
    e.stopPropagation();
    $(e.target).accordion('hide');
  })
  // this is so that we don't need to use a unique id (as per Bootstrap) for every single accordion
  .on('click.bc.accordion', '[data-toggle="collapse"]', function (e) {
    e.preventDefault();
    $(this).accordion('toggle');
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/accordion.js
// module id = 1
// module chunks = 0